import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { z } from "zod";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { CreditCardForm } from "@/components/payment/forms/credit-card-form";

import type { JSX } from "react";

const createCardOptionSchema = z.object({
  action: z.string().optional(),
});

const CardCreatePage = (): JSX.Element => {
  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Cadastrar cartão" align="center" />
      </HeaderRoot>
      <Page>
        <CreditCardForm />
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/profile/card/create")({
  component: CardCreatePage,
  validateSearch: createCardOptionSchema,
});
